import { Link } from "react-router-dom";
import { categories } from "@/mocks/posts";

export default function CategorySection() {
  return (
    <section className="w-full bg-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="mb-8 max-w-2xl">
          <span className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
            <i className="ri-compass-3-line" aria-hidden="true"></i>
            分类基地
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            四大吃瓜基地，总有一款合你口味
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            从娱乐圈到写字楼，从街头巷尾到行业深处，你想吃的瓜都在这里。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((item, index) => (
            <Link
              key={item.slug}
              to={`/category/${item.slug}`}
              className="group flex flex-col rounded-lg border border-background-200/70 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-lg text-2xl ${
                  index % 2 === 0
                    ? "bg-primary-100 text-primary-600"
                    : "bg-accent-100 text-accent-700"
                }`}
              >
                <i className={item.icon} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                {item.name}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                {item.description}
              </p>
              <div className="mt-4 flex items-center justify-between border-t border-background-200/70 pt-3">
                <span className="text-xs text-foreground-500">
                  {item.count} 条内容
                </span>
                <span className="flex items-center gap-1 text-xs font-semibold text-primary-600 transition-transform group-hover:translate-x-1">
                  进入
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}